export enum PresenceStatus {
  Unconfirmed = 'Unconfirmed',
  Present = 'Present',
  JustifiedAbsence = 'JustifiedAbsence',
  UnjustifiedAbsence = 'UnjustifiedAbsence',
  Discharge = 'Discharge',
  LateArrival = 'LateArrival',
  EarlyDeparture = 'EarlyDeparture',
  ComplementaryService = 'ComplementaryService'
}
